module.exports = __webpack_public_path__ + "img/valve_opening.446f373a.svg";